@if (haveEnrollmentOptions && modeForm) {
<div>
  @if (welcomeMessage) {
    <div [innerHTML]="welcomeMessage | pipeSafeHTML" class="message-container green-fill fw-bold mb-3">
    </div>
  }
  <div class="content-container blue-fill mb-3">
    <div class="title">
      @if (!enrollmentInProgress) {
        <mwp-text-translate text="ENROLLMENT SESSION" jsonKey="enrollmentSession" />
      } @else {
        <mwp-text-translate text="ENROLLMENT IN PROGRESS" jsonKey="onboardingEnrollmentInProgess" />
      }
    </div>
    <div class="content">
      <form [formGroup]="modeForm">
        <div [formArrayName]="modeFormArrayName" class="w-100">
          @for (mode of gridModeArray; track mode; let i = $index) {
            <div [formGroupName]="i" class="w-100 d-inline-flex">
              <div class="w-100">
                <div class="fw-bold">
                  {{ mode.value.name }}
                </div>
                <!-- <div class="d-inline-flex fw-bold">
                    <span class="me-2">Expires:</span>
                    <span>{{ mode.value.expireDate }}</span>
                  </div> -->
                <div [innerHTML]="mode.value.message | pipeSafeHTML" class="mb-3"></div>
              </div>
              <div class="align-content-center justify-content-end ms-3">
                @if (!enrollmentInProgress) {
                  <button class="mwp-button text-nowrap" (click)="continueWizard()">
                    <mwp-text-translate text="Begin Enrollment" jsonKey="beginEnrollment" />
                  </button>
                } @else {
                  <button class="mwp-button text-nowrap" (click)="continueSession()">
                    <mwp-text-translate text="Continue Enrollment Session" jsonKey="onboardingContinueEnrollmentSession" />
                  </button>
                }
              </div>
            </div>
          }
        </div>
      </form>
    </div>
  </div>
</div>
}
@if (!haveEnrollmentOptions) {
<div class="message-container blue-fill text-centered">
  <mwp-text-translate text="You do not have enrollment sessions currently available." jsonKey="modeNoEnrollmentSessions" />
</div>
}